// Copyright (c) 2017 Deere & Company

const laborRateChangesFilterOptions = [
    ['responsibleAccount', 'name'],
    ['requestId']
];

export default laborRateChangesFilterOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/labor-rate-changes-filter-options.js